export default "__VITE_ASSET__1523921a__"